import { createClient } from '@supabase/supabase-js';
import { Database } from 'types/supabase';

// Use environment variables for Supabase credentials
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://emsuvnqvhgjrnozpdofu.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtc3V2bnF2aGdqcm5venBkb2Z1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU4ODUzMjIsImV4cCI6MjA2MTQ2MTMyMn0.uRub5hf8xN5OOfQS0MncyM_dfaPQbpjHZ8I5Z7m2QEM';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

// Helper function to save simulation results
export const saveSimulation = async (
  simulatorType: string,
  originWebsite: string, 
  userEmail: string | null,
  inputs: any,
  results: any
) => {
  try {
    const { data, error } = await supabase
      .from('simulations')
      .insert([
        {
          simulator_type: simulatorType,
          origin_website: originWebsite,
          user_email: userEmail,
          inputs: inputs,
          results: results
        }
      ]);
      
    if (error) {
      console.error('Error saving simulation:', error);
      return { success: false, error };
    }
    
    return { success: true, data };
  } catch (error) {
    console.error('Exception saving simulation:', error);
    return { success: false, error };
  }
}; 